export enum LoaderTypes {
    FOREGROUND = '1',
    BACKGROUND = '-1',
    MASTER = '0'
}
